import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef, output, inject } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommonPdfPopupComponent } from '@fitness-force/common-pdf-popup';
import { PdfData, PdfType } from '@fitness-force/models';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'number-prefix',
  templateUrl: './number-prefix.component.html',
  providers: [DialogService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TooltipModule, TranslateModule, AsyncPipe]
})
export class NumberPrefixComponent implements OnInit {
  private dialogService = inject(DialogService);
  private cd = inject(ChangeDetectorRef);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null); 
  readonly onAction = output<{ action: string; columnData: any }>();

  refServiceModal: DynamicDialogRef | null;

  ngOnInit(): void {
  }

  OpenPdf(pdfType:PdfType, columnData:any, additionData:any, numberPrefix:string)
  {
    let data:PdfData ={} as PdfData;
    switch (pdfType) {
      case PdfType.Invoice:
        {
          if(columnData['invoices'] && columnData['invoices'].length > 0)
          {
            let invoiceData= columnData['invoices'].find((i: { number_prefix: string; }) => i.number_prefix == numberPrefix)!;
            data = {
              type: PdfType.Invoice,
              primaryId: invoiceData.id,
              secondaryId: 0,
              numberPrefix: invoiceData.number_prefix,
              status: invoiceData.status,
              clientId: invoiceData.client_id,
              tenantId: invoiceData.tenant_id
            }
          }
          else{
            data = {
              type: PdfType.Invoice,
              primaryId: columnData[additionData.id],
              secondaryId: 0,
              numberPrefix: columnData[additionData.fetch_key],
              status: columnData["status"],
              clientId: columnData["client_id"],
              tenantId: columnData["tenant_id"]
            }
          }
        }
        break;
      case PdfType.Payment:
        {
          data = {
            type: PdfType.Payment,
            primaryId: columnData[additionData.id],
            secondaryId: 0,
            numberPrefix: columnData[additionData.fetch_key],
            status: columnData["status"],
            clientId: columnData["client_id"],
            tenantId: columnData["collected_at_tenant_id"]
          }
        }
        break;
      case PdfType.SalesReturn:
        {
          data = {
            type: PdfType.SalesReturn,
            primaryId: columnData[additionData.id],
            secondaryId: columnData["invoice_id"],
            numberPrefix: columnData[additionData.fetch_key],
            status: columnData["is_void"] == true ? "void" : "",
            clientId: columnData["client_id"],
            tenantId: columnData["tenant_id"]
          }
        }
        break;
      case PdfType.Refund:
        {
          data = {
            type: PdfType.Refund,
            primaryId: columnData[additionData.id],
            secondaryId: 0,
            numberPrefix: columnData[additionData.fetch_key],
            status: columnData["refund_status"],
            clientId: columnData["client_id"],
            tenantId: columnData["tenant_id"]
          }
        }
        break;
    }

    this.refServiceModal = this.dialogService.open(CommonPdfPopupComponent, {
      showHeader: false,
      width: '820px',
      baseZIndex: 10000,
      modal: true,
      appendTo: 'body',
      styleClass: 'no-header-modal',
      contentStyle: { 'overflow': 'hidden', 'padding': '0' },
      breakpoints: {
        '767px': '100vw',
      },
      data,
    });

    if (this.refServiceModal) {
    this.refServiceModal.onClose.subscribe((res: PdfData) => {
      if(res && res != null)
      {
        if(res.type == PdfType.SalesReturn) columnData["is_void"] = res.status =='void' ? true : false;
        else columnData["status"] = res.status;
        this.onAction.emit({action:'updatedata',columnData:columnData});
      }
        this.cd.detectChanges();
      });
    }
  }

  get getPdfType()
  {
    return PdfType;
  }
}